import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, token } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0c] text-[#e6c687]">
        <div className="pfi-overline">Loading…</div>
      </div>
    );
  }
  if (!user || !token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
